(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cubsley-header"]) return;
  try {
    
document.addEventListener('click', event => {
  document.querySelectorAll('.cb-mobile-menu[open]').forEach(menu => {
    if (!menu.contains(event.target)) menu.removeAttribute('open');
  });
});
document.addEventListener('keydown', event => {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('.cb-mobile-menu[open]').forEach(menu => {
    menu.removeAttribute('open');
    menu.querySelector('summary').focus();
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cubsley-product"]) return;
  try {
    
document.addEventListener('change', event => {
  const select = event.target;
  if (!(select instanceof HTMLSelectElement) || !select.matches('[data-cb-variant]')) return;
  const section = select.closest('.cb-pdp');
  const option = select.selectedOptions[0];
  const form = select.form;
  if (!section || !option || !form) return;

  const price = section.querySelector('[data-cb-price]');
  if (price) price.textContent = option.dataset.price;

  const available = option.dataset.available === 'true';
  const addButton = form.querySelector('button[name="add"]');
  if (addButton) {
    const label = available ? addButton.dataset.addLabel : addButton.dataset.soldOutLabel;
    addButton.disabled = !available;
    addButton.setAttribute('aria-label', label);
    const labelNode = addButton.querySelector('[data-cb-add-label]');
    if (labelNode) labelNode.textContent = label;
  }
  const dynamicCheckout = form.querySelector('[data-cb-dynamic-checkout]');
  if (dynamicCheckout) dynamicCheckout.hidden = !available;

  const quantity = form.querySelector('input[name="quantity"]');
  if (quantity) {
    const minimum = Number(option.dataset.quantityMin) || 1;
    const increment = Number(option.dataset.quantityStep) || 1;
    const maximum = option.dataset.quantityMax ? Number(option.dataset.quantityMax) : null;
    quantity.min = String(minimum);
    quantity.step = String(increment);
    if (maximum !== null) quantity.max = String(maximum);
    else quantity.removeAttribute('max');
    let value = Math.max(minimum, Number(quantity.value) || minimum);
    value = minimum + Math.ceil((value - minimum) / increment) * increment;
    if (maximum !== null && value > maximum) {
      value = minimum + Math.floor((maximum - minimum) / increment) * increment;
    }
    quantity.value = String(Math.max(minimum, value));
  }

  const gallery = section.querySelector('.cb-pdp-gallery');
  const media = gallery && Array.from(gallery.children).find(item => item.dataset.cbMediaId === option.dataset.mediaId);
  if (media && gallery.firstElementChild !== media) {
    const previousImage = gallery.firstElementChild?.querySelector('img');
    if (previousImage) previousImage.sizes = '(max-width:749px) 90vw, 26vw';
    const image = media.querySelector('img');
    if (image) {
      image.loading = 'eager';
      image.sizes = '(max-width:749px) 90vw, 52vw';
    }
    gallery.prepend(media);
    gallery.scrollTo({ left: 0, behavior: 'instant' });
  }

  const url = new window.URL(window.location.href);
  url.searchParams.set('variant', select.value);
  window.history.replaceState(window.history.state, '', url.href);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
